<div class = "upload-files-component">
    <div class="upload-files-header">
        <button class="all-files-button">All Files</button>
        <div class="upload-files-header-right">
            <div class="upload-files-search">
            <img src = "../../assets/icons/search.svg" alt = "search icon" class="search-icon"/>
            <input class="upload-files-search-input" type = "search" placeholder="Enter keyword to search" #searchInput (keyup)="onSearch(searchInput.value)"/>
            </div>
            <div class="upload-files-upload-icon" (click)="onUploadLocalFilesClick()">
                <img src="../../assets/icons/upload-files.svg" alt="Upload Files Icon" class="upload-files-icon">
            </div>
        </div>
    </div>
    <div class = "files-container">
    <ng-container *ngIf="isLoading; else filesBlock">
      <div class="files-empty-state">Loading your files...</div>
    </ng-container>
    <ng-template #filesBlock>
      <ng-container *ngIf="retrievedFiles && retrievedFiles.length > 0; else noFiles">
        <div *ngFor = "let file of retrievedFiles; let i = index" class = "files-list">
            <input type="checkbox" [value]="file" [id]="'file-' + i" (change)="onCheckboxChange(file, $event)"/>
            <label [for]="'file-' + i" class="file-label">
              <img src="{{ getFilePrefix(file.documentName) }}" alt="File Icon" class="file-icon"/>
              <div class = "filename-duration">
                <p style = "margin: 0px;">{{ file.documentName }}</p>
                <p class = "duration">uploaded {{fileUploadDuration(file.updateTime.toString())}} ago</p>
          </div>
            </label>
        </div>
      </ng-container>
      <ng-template #noFiles>
        <div class="files-empty-state">There are no files.</div>
      </ng-template>
    </ng-template>
    </div>
</div>